import request from '../_helpers/request';

const SALES_LEAD_PAGE_SIZE = 15;

export const InquiryFormService = {
    GetInquiryByAccount,
    GetInquiryList,
    GetAllSalesLeadList,
    GetInquiryDetail,
    GetUnreadNum,
    GetSourcingMatching,
    GetSourcingMatchingDetail,
    GetSourcingContactBuyer,
    GetSourcingContactBuyerDetail,
    GetUnlockQuotaFree,
    AddUnlockQuotaFree,
    GetNameCardList,
    GetNameCardDetail,
    GetLikeFollowList,
    GetLikeFollowDetail,
    GetLikeFollowReplyInfo,
    ReplyLikeFollow,
    ReplyNameCard,
    GetNameCardReplyContacts,
    GetSupplierReplyNameCard,
    ExportSalesLeads,
    ReleaseSalesLeadExportLease,
    GetSalesLeadExportStatus,
    GetSalesLeadExportMeta,
};
function GetUnreadNum(companyId){
    const url = "InquiryForm/GetUnreadNum";
    const query = {
        "companyId": companyId, 
        
    };

    return request({
        url:url,
        method:'post',
        params:query
    })
    .then(res => {
            return res.data
        })
}
function buildSalesLeadListParams(companyId, keyword, options = {}) {
    const query = {
        companyId,
        keyword: keyword || '',
    };
    if (options.pageIndex != null) {
        query.pageIndex = options.pageIndex;
        query.pageSize = options.pageSize ?? SALES_LEAD_PAGE_SIZE;
    }
    if (options.unreadOnly) {
        query.unreadOnly = true;
    }
    return query;
}

function GetInquiryList(companyId, keyword, options = {}) {
    const url = "InquiryForm/GetInquiryList";
    const params = buildSalesLeadListParams(companyId, keyword, options);
    return request({
        url,
        method: 'post',
        params,
    }).then((res) => {
        return res;
    });
}

function GetAllSalesLeadList(companyId, keyword, options = {}) {
    const url = "InquiryForm/GetAllSalesLeadList";
    const query = buildSalesLeadListParams(companyId, keyword, {
        pageIndex: options.pageIndex ?? 1,
        pageSize: options.pageSize ?? SALES_LEAD_PAGE_SIZE,
        unreadOnly: options.unreadOnly,
    });
    return request({
        url,
        method: 'post',
        params: query,
    }).then((res) => {
        return res;
    });
}
function GetInquiryDetail(rid) {
    const url = "InquiryForm/GetInquiryDetail";
    const params = {"rid":rid};

    return request({url:url, method: 'post',params:params})
        .then(res => {
            return res.data;
        })

}
function GetInquiryByAccount(UniqueCode) {
    var url = "InquiryForm/GetInquiryByAccount";
    var params = {"UniqueCode":UniqueCode, "action": {
        "LangId": localStorage.getItem("currentLangId")
        , "IP": window.location.host
        , "URL": window.location.href
        , "Referral": document.referrer
        , "BAgent": window.navigator.userAgent

    }};

    return request.post(url, params)
        .then(res => {
            if (res.data) {
                return res.data;
            } else {
                return error;
            }
        })

}


function GetSourcingMatching(query) {
  const params = { ...query };
  if (query.pageIndex != null) {
    params.pageSize = query.pageSize ?? SALES_LEAD_PAGE_SIZE;
    if (query.unreadOnly) params.unreadOnly = true;
  }
  return request({
    url: 'InquiryForm/GetSourcingMatching',
    method: 'post',
    params,
  }).then(res => res.data);
}

function GetSourcingMatchingDetail(query){
  return request({
    url:'InquiryForm/GetSourcingMatchingDetail',
    method:'post',
    params:query
  }).then(res => {
    return res.data;
  });
}



function GetSourcingContactBuyer(query) {
  const params = { ...query };
  if (query.pageIndex != null) {
    params.pageSize = query.pageSize ?? SALES_LEAD_PAGE_SIZE;
    if (query.unreadOnly) params.unreadOnly = true;
  }
  return request({
    url: 'InquiryForm/GetSourcingContactBuyer',
    method: 'post',
    params,
  }).then(res => res.data);
}
function GetSourcingContactBuyerDetail(query){
  return request({
    url:'InquiryForm/GetSourcingContactBuyerDetail',
    method:'post',
    params:query
  }).then(res => {
    return res.data;
  });
}

function GetUnlockQuotaFree(query)
{
    return request({
    url:'InquiryForm/GetUnlockQuotaFree',
    method:'post',
    params:query
  }).then(res => {
    return res.data;
  });
}


function AddUnlockQuotaFree(data){
  return request({
    url:'InquiryForm/AddUnlockQuotaFree',
    method:'post',
    data:data
  })
}

function GetNameCardList(companyId, keyword, options = {}) {
    const url = "InquiryForm/GetNameCardList";
    const params = buildSalesLeadListParams(companyId, keyword, options);
    return request({
        url,
        method: 'post',
        params,
    })
    .then((res) => {
        return res;
    })
    .catch((err) => {
        return {
            isSuccessful: false,
            systemErrorMsg: [err && (err.message || String(err))],
        };
    });
}

function GetNameCardDetail(query){
  return request({
    url:'InquiryForm/GetNameCardDetail',
    method:'post',
    params:query
  }).then(res => {
    return res.data;
  }).catch(() => {
    // Return empty array if API is not ready yet
    return [];
  });
}

// Like/Follow list - mirror NameCard list contract
function GetLikeFollowList(companyId, keyword, options = {}) {
    const url = "InquiryForm/GetLikeFollowList";
    const params = buildSalesLeadListParams(companyId, keyword, options);
    return request({
        url,
        method: "post",
        params,
    })
    .then((res) => {
        return res;
    })
    .catch((err) => {
        return {
            isSuccessful: false,
            systemErrorMsg: [err && (err.message || String(err))],
        };
    });
}

// Like/Follow detail - backend-first, fallback handled by caller
function GetLikeFollowDetail(query) {
    return request({
        url: "InquiryForm/GetLikeFollowDetail",
        method: "post",
        params: query
    })
    .then(res => {
        return res.data;
    })
    .catch(() => {
        return null;
    });
}

function GetLikeFollowReplyInfo(query) {
    return request({
        url: "InquiryForm/GetLikeFollowReplyInfo",
        method: "post",
        params: query
    })
    .then(res => {
        return res.data;
    })
    .catch(() => {
        return null;
    });
}

function ReplyLikeFollow(data) {
  return request({
    url: "InquiryForm/ReplyLikeFollow",
    method: "post",
    data: data
  }).then(res => {
    return res.data;
  });
}

function GetNameCardReplyContacts(langId) {
    const url = "InquiryForm/GetNameCardReplyContacts";
    const query = {
        "langId": langId
    };

    return request({
        url: url,
        method: 'post',
        params: query
    })
    .then(res => {
        return res.data;
    })
    .catch(() => {
        return [];
    });
}

function ReplyNameCard(data) {
  return request({
    url: 'InquiryForm/ReplyNameCard',
    method: 'post',
    data: data
  }).then(res => {
    return res.data;
  });
}

function GetSupplierReplyNameCard(nameCardRequestId) {
    const url = "InquiryForm/GetSupplierReplyNameCard";
    const query = {
        "nameCardRequestId": nameCardRequestId
    };

    return request({
        url: url,
        method: 'post',
        params: query
    })
    .then(res => {
        return res.data;
    })
    .catch(() => {
        return null;
    });
}

/**
 * 销售线索导出（统一 16 列；服务端按 Detail 脱敏）
 * @param {string} leadType inquiry | nameCard | likeFollow | matched | applied | all
 */
function ExportSalesLeads(companyId, keyword, options = {}) {
    const langId = options.langId != null
        ? options.langId
        : parseInt(localStorage.getItem('currentLangId'), 10) || 936;
    const query = {
        companyId,
        keyword: keyword || '',
        unreadOnly: !!options.unreadOnly,
        langId,
        leadType: options.leadType || 'all',
    };
    if (options.fromDate) query.fromDate = options.fromDate;
    if (options.toDate) query.toDate = options.toDate;
    return request({
        url: 'InquiryForm/ExportSalesLeads',
        method: 'post',
        params: query,
        timeout: 300000,
    });
}

function ReleaseSalesLeadExportLease(params) {
    return request({
        url: 'InquiryForm/ReleaseSalesLeadExportLease',
        method: 'post',
        data: params,
    }).catch((err) => ({
        isSuccessful: false,
        msg: [err?.message || 'ReleaseSalesLeadExportLease failed'],
    }));
}

function GetSalesLeadExportStatus(companyId) {
    return request({
        url: 'InquiryForm/GetSalesLeadExportStatus',
        method: 'post',
        params: { companyId },
    })
        .then((res) => {
            const ok = res?.isSuccessful ?? res?.IsSuccessful;
            if (!ok) return { exportInProgress: false };
            return res?.data ?? res?.Data ?? { exportInProgress: false };
        })
        .catch(() => ({ exportInProgress: false }));
}

function GetSalesLeadExportMeta() {
    return request({
        url: 'InquiryForm/GetSalesLeadExportMeta',
        method: 'post',
    }).then((res) => {
        return res?.data ?? res?.Data ?? res;
    }).catch(() => null);
}